import MarkdownToJsx, { MarkdownToJSX } from "markdown-to-jsx";

interface MarkdownProps {
    children: string;
    className?: string;
    /** Merged over the safe defaults ({ disableParsingRawHTML: true }). */
    options?: MarkdownToJSX.Options;
}

/** Markdown renderer with raw-HTML parsing disabled by default. */
export const Markdown = ({ children, className, options }: MarkdownProps) => (
    <MarkdownToJsx
        className={className}
        options={{ disableParsingRawHTML: true, ...options }}
    >
        {children}
    </MarkdownToJsx>
);
